import interceptor from "../common/interceptor";
import { APIPaths } from "../common/constants";

export const GetMessages = (token) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosGet("Get", APIPaths.conversations,token,null).then(res => {
            resolve(res);
        }).catch(error => {
            console.log("error?.response?.data?.error", error?.response);
            reject(error?.response);
        })
    });
};
export const GetUserMessages = (token, userId) => {
    return new Promise((resolve, reject) => {
        const apiUrl = `${APIPaths.user_conversation}${userId}/messages/`; 
        interceptor.axiosGet("Get", apiUrl, token, null)
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                console.log("error?.response?.data?.error", error?.response);
                reject(error?.response);
            });
    });
};

